import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'azc-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	public showSurvey: boolean;

	constructor() { }

	ngOnInit() {
	}

}
